import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

// Bloquear la orientación solo en dispositivos móviles
if (isMobileDevice() && window.screen && window.screen.orientation) {
  window.screen.orientation.lock('portrait').catch(error => {
    console.error('Error locking screen orientation:', error);
  });
}

// Función para verificar si es un dispositivo móvil
function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
